export default __webpack_public_path__ + "static/media/projects_credits.f222401b.csv";